import { defineStore } from 'pinia'

const useAppStore = defineStore('app', {
  state: () => ({
    profile: null,
    isBoundTelegram: false,
    serviceContentVisible: false,
    serviceBadgeCount: {
      all: 0,
      pendingPrice: 0,
      pendingDispatch: 0,
    },
    allowedProjects: [],
    allowedServiceCategories: [],
    allowedServiceTypes: [],
    allowedServiceSubTypes: [],
    serviceCategories: [],
  }),
  getters: {
    isAuthenticated(state) {
      return !!state.profile
    },
    isServiceContentVisible(state) {
      return state.serviceContentVisible
    },
  },
  actions: {
    setProfile(_profile) {
      this.profile = _profile
    },
    setBoundTelegram(_isBoundTelegram) {
      this.isBoundTelegram = _isBoundTelegram
    },
    setServiceContentVisible(_serviceContentVisible) {
      this.serviceContentVisible = _serviceContentVisible
    },
    setServiceBadgeCount(_serviceBadgeCount) {
      if (this.serviceCategories.length === 0) {
        this.serviceBadgeCount = {
          all: 0,
          pendingPrice: 0,
          pendingDispatch: 0,
        }
      } else this.serviceBadgeCount = _serviceBadgeCount
    },
    resetServiceBadgeCount() {
      this.serviceBadgeCount = {
        all: 0,
        pendingPrice: 0,
        pendingDispatch: 0,
      }
    },
    setAllowed({
      projects = [],
      serviceCategories = [],
      serviceTypes = [],
      serviceSubTypes = [],
    }) {
      this.allowedProjects = projects
      this.allowedServiceCategories = serviceCategories
      this.allowedServiceTypes = serviceTypes
      this.allowedServiceSubTypes = serviceSubTypes
    },
    setServiceCategories(_serviceCategories) {
      this.serviceCategories = _serviceCategories
    },
  },
})

export default useAppStore
